import TrustpilotSlider3Items from './TrustpilotSlider3Items'

export default TrustpilotSlider3Items
